interface ToggleSwitchProps {
  checked: boolean;
  onChange: () => void;
  label?: string;
}

export default function ToggleSwitch({ checked, onChange, label }: ToggleSwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label || "تفعيل / تعطيل"}
      onClick={onChange}
      className={`relative w-12 h-7 rounded-full shrink-0 transition-colors duration-200 cursor-pointer ${
        checked ? "bg-primary-500" : "bg-background-400"
      }`}
    >
      <span
        className={`absolute top-1 w-5 h-5 rounded-full bg-white shadow-sm transition-all duration-200 ${
          checked ? "left-1" : "right-1"
        }`}
      ></span>
    </button>
  );
}